import { render } from "./Icon.vue?vue&type=template&id=512f27ae&scoped=true&ts=true"
import script from "./Icon.vue?vue&type=script&lang=ts"
export * from "./Icon.vue?vue&type=script&lang=ts"

import "./Icon.vue?vue&type=style&index=0&id=512f27ae&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-512f27ae"]])

export default __exports__